import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Directive({
    selector: '[appTwoDigitDecimal]',
    standalone: false
})
export class TwoDigitDecimalDirective {
  private regex: RegExp = new RegExp(/^-?\d*\.?\d{0,2}$/);

  @Input() inputModifierForm! : FormGroup;
  @Input() metricId:string ='';

  // Special keys to allow
  private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Del', 'Delete'];

  constructor(private el: ElementRef) { }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    // Allow special keys
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }

    // Block if not a number, period, or minus
    if (!/[\d.\-]/.test(event.key)) {
      event.preventDefault();
      return;
    }

    const current: string = this.el.nativeElement.value;
    const position = this.el.nativeElement.selectionStart || 0;
    const next: string = [
      current.slice(0, position),
      event.key === 'Decimal' ? '.' : event.key,
      current.slice(position)
    ].join('');

    // Additional check for decimal places
    if (next.includes('.')) {
      const parts = next.split('.');
      if (parts[1] && parts[1].length > 2) {
        event.preventDefault();
        return;
      }
    }

    // Check against regex
    if (next && !String(next).match(this.regex)) {
      event.preventDefault();
    }
  }

  // Handle input event as a safeguard
  @HostListener('input', ['$event'])
  onInput(event: Event) {
  const current: string = this.el.nativeElement.value;
  if (this.metricId) {
  this.inputModifierForm.get(this.metricId)?.setValue(current);
  if (Number(current) <= 0) {
    this.inputModifierForm.get(this.metricId)?.setErrors({ min: true });
    }
  }

    if (current && current.includes('.')) {
      const parts = current.split('.');
      if (parts[1] && parts[1].length > 2) {
        // Truncate to 2 decimal places immediately
        this.el.nativeElement.value = `${parts[0]}.${parts[1].substring(0, 2)}`;
      }
    }

    this.validateAndSetError();
  }

  @HostListener('blur', ['$event'])
  onBlur(event: FocusEvent) {
    const value: string = this.el.nativeElement.value;

    if (value && value.includes('.')) {
      const parts = value.split('.');
      if (parts[1] && parts[1].length > 2) {
        this.el.nativeElement.value = `${parts[0]}.${parts[1].substring(0, 2)}`;
      }
    }
  }

  private validateAndSetError(): void {
    const control = this.getControl(this.metricId);
    if (!control) {
      return;
    }

    const value = this.el.nativeElement.value;

    if (value === '') {
      control.setErrors(null);
      return;
    }

    const numValue = Number(value);
    if (isNaN(numValue) || numValue <= 0) {
      control.setErrors({ min: true });
    }
  }

  private getControl(id: string) {
    if (!this.inputModifierForm) {
      return null;
    }
    return this.inputModifierForm.get(id);
  }  
}
